<template>
  <v-container style="height: 88vh" v-if="!loading" class="d-block">
    <v-row class="my-6">
      <v-col v-for="(item, i) in data" :key="i" lg="3">
        <edu-card :data="item" />
      </v-col>
    </v-row>
    <pagination @updatePage="getData({ page: $event })" :data="meta" />
  </v-container>
  <pulse-loader
    v-else
    :loading="true"
    :color="$vuetify.theme.themes.light.primary"
    size="20px"
  />
</template>
<script>
import { eduClass } from "@/store/teacher/eduClass/index";
import eduCard from "./eduCard.vue";
export default {
  components: {
    eduCard,
  },
  data() {
    return {
      eduClass,
    };
  },
  methods: {
    getData(params) {
      eduClass.get(params);
    },
  },
  computed: {
    data() {
      return eduClass.tableData.data;
    },
    meta() {
      return eduClass.tableData.meta;
    },
    loading() {
      return eduClass.getState.loading;
    },
  },
  mounted() {
    this.getData({ page: 1 });
  },
};
</script>
